import { render, staticRenderFns } from "./LabelIcon.vue?vue&type=template&id=3043449e"
import script from "./LabelIcon.vue?vue&type=script&lang=js"
export * from "./LabelIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports